import {Component, Input, ElementRef, HostBinding, AfterViewInit, OnDestroy} from '@angular/core';
declare var $: any;
//import 'owl-carousel';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'imports?jQuery=jquery!owl.carousel';

@Component({
    selector: 'owl-carousel',
    template: `<ng-content></ng-content>`
})
export class OwlCarousel implements AfterViewInit,OnDestroy {
    @HostBinding('class') defaultClass = 'owl-carousel';
    @Input() options: Object;

    $owlElement: any;

    defaultOptions: any = {};

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit() {
        // use default - empty
        for (var key in this.options) {
            this.defaultOptions[key] = this.options[key];
        }
        if ($(window).width() < 769) {
            this.defaultOptions["items"] = 1;
            this.defaultOptions["mouseDrag"] = true;
        }
        else
            this.defaultOptions["items"] = 3;
        this.$owlElement = $(this.el.nativeElement).owlCarousel(this.defaultOptions);
        this.$owlElement.on('initialized.owl.carousel', function (event) {
        });

        //Cambiar opciones cuando cambia de tamaño la pantalla
        window.onresize = function () {
            var carousel = this.$owlElement.data('owl.carousel');
            if ($(window).width() < 769) {
                carousel.options.items = 1;
                carousel.options.mouseDrag = true;
            }
            else{
                carousel.options.items = 3;
                carousel.options.mouseDrag = false;
            }
            this.$owlElement.trigger('refresh.owl.carousel');
        }.bind(this);
    }

    ngOnDestroy() {
        //this.$owlElement.data('owlCarousel').destroy();
        this.$owlElement = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/carousel/owl-carousel.component.ts